import type { MessageDescriptor } from 'react-intl';

import { BillingPlanIds, isPremiumPlan, isStandardPlan, isStarterPlan } from '../../../../../../../enums/billing-plan-ids';

import { messages } from './messages';

const FREE_HIGHLIGHTS: ReadonlyArray<MessageDescriptor> = [
  messages.discountedCarrierRates,
  messages.trackingEmails,
  messages.oneStoreConnection,
];

const STARTER_HIGHLIGHTS: ReadonlyArray<MessageDescriptor> = [
  messages.unlimitedStoreConnections,
  messages.automatedRateShopping,
  messages.returnLabels,
  messages.basicAutomations,
  messages.reporting,
  messages.chatSupport,
];

const STANDARD_HIGHLIGHTS: ReadonlyArray<MessageDescriptor> = [
  messages.unlimitedAutomations,
  messages.combineSplitOrders,
  messages.bringYourExistingCarrierAccount,
  messages.advancedReturnFeatures,
  messages.basicWarehouseManagementAndInventorySync,
  messages.inventoryTrackingSyncAndProductBundles,
  messages.shippingAPI,
  messages.phoneSupport,
];

const PREMIUM_HIGHLIGHTS: ReadonlyArray<MessageDescriptor> = [
  messages.inventoryManagement,
  messages.advancedWarehouse,
  messages.customAnalytics,
  messages.autoRouting,
  messages.cubiscan,
  messages.openDatabaseConnectivity,
];

export const getPlanHighlightsMessages = (billingPlanId: string | number | null | undefined): ReadonlyArray<MessageDescriptor> | null => {
  if (billingPlanId == null) return null;

  const parsed = typeof billingPlanId === 'number' ? billingPlanId : parseInt(String(billingPlanId), 10);

  if (parsed === BillingPlanIds.Free2025Q2) return FREE_HIGHLIGHTS;
  if (isStarterPlan(billingPlanId)) return STARTER_HIGHLIGHTS;
  if (isStandardPlan(billingPlanId)) return STANDARD_HIGHLIGHTS;
  if (isPremiumPlan(billingPlanId)) return PREMIUM_HIGHLIGHTS;

  return null;
};
